import type { ThemeConfig } from '@/types/theme'
import { ColorPickerField } from '@/components/Configuracao/AppearanceColorPickerField'
import { APPEARANCE_COLOR_GROUPS } from '@/components/Configuracao/appearanceColorGroups'

type Props = {
  draft: ThemeConfig
  onClearPreset: () => void
  updateDraft: (patch: Partial<ThemeConfig>) => void
}

export function AppearanceCoresManualGroups({ draft, onClearPreset, updateDraft }: Props) {
  return (
    <>
      {APPEARANCE_COLOR_GROUPS.map((group) => (
        <div key={group.title} className="glass-card p-5 space-y-4">
          <div>
            <h3 className="text-text-primary font-semibold text-sm flex items-center gap-2">
              {group.icon}
              {group.title}
            </h3>
            <p className="text-text-muted text-[11px] mt-0.5">{group.desc}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {group.colors.map((color) => (
              <ColorPickerField
                key={color.key}
                label={color.label}
                value={(draft[color.key] as string) ?? '#000000'}
                supportsAlpha={color.supportsAlpha}
                onChange={(v) => {
                  onClearPreset()
                  updateDraft({ [color.key]: v })
                }}
              />
            ))}
          </div>
        </div>
      ))}
    </>
  )
}
